const URL_CAZANA = 'https://percayso-vehicle-intelligence.co.uk'
const URL_PERCAYSO = 'https://www.percayso-inform.com'

export const menuColumns = [
  {
    title: 'About',
    links: [
      {
        label: 'Cazana',
        href: `${URL_CAZANA}`
      }
    ]
  },
  {
    title: 'Products',
    links: [
      {
        label: 'Companion',
        href: `${URL_CAZANA}/products/companion`
      },
      {
        label: 'Multi',
        href: `${URL_CAZANA}/products/multi`
      },
      {
        label: 'API & Data Solutions',
        href: `${URL_CAZANA}/products/api-data-solutions`
      }
    ]
  },
  {
    title: 'Solutions',
    links: [
      {
        label: 'Insurance',
        href: `${URL_CAZANA}/solutions/insurance`
      },
      {
        label: 'Lenders',
        href: `${URL_CAZANA}/solutions/lenders`
      },
      {
        label: 'Vehicle Manufacturers',
        href: `${URL_CAZANA}/solutions/vehicle-manufacturers`
      },
      {
        label: 'Partners',
        href: `${URL_CAZANA}/solutions/partnerships-and-resellers`
      }
    ]
  },
  {
    title: 'Resources',
    links: [
      {
        label: 'Our Blog',
        href: `${URL_CAZANA}/pvi-blog`
      }
    ]
  }
]

export const legalLinks = [
  {
    label: 'Modern Slavery Statement',
    href: `${URL_PERCAYSO}/modern-slavery-statement`,
    target: '_blank',
    rel: 'noopener'
  },
  {
    label: 'Careers',
    href: `${URL_PERCAYSO}`,
    target: '_blank',
    rel: 'noopener'
  },
  {
    label: 'Privacy Policy',
    href: `${URL_PERCAYSO}/privacy-policy`,
    target: '_self',
    rel: 'noopener'
  },
  {
    label: 'User Terms',
    href: `${URL_PERCAYSO}/user-terms`,
    target: '_self',
    rel: 'noopener'
  },
  {
    label: 'Cookie policy',
    href: `${URL_PERCAYSO}/cookie-policy`,
    target: '_self',
    rel: 'noopener'
  }
]

export const socialLinks = [
  {
    name: 'LinkedIn',
    href: 'https://www.linkedin.com/company/percaysoinformvehicleintelligence',
    iconClass: 'fab fa-linkedin is-size-4'
  },
  {
    name: 'Twitter',
    href: 'https://twitter.com/PercaysoInform',
    iconClass: 'fab fa-twitter is-size-4'
  }
]

export const contactInfo = {
  title: 'Contact us',
  addressLines: ['Hine House', '25 Regent Street', 'Nottingham', 'NG1 5BS']
}
